import { render } from "./Page-Home.vue?vue&type=template&id=f96b62d4&scoped=true"
import script from "./Page-Home.vue?vue&type=script&lang=js"
export * from "./Page-Home.vue?vue&type=script&lang=js"

import "./Page-Home.vue?vue&type=style&index=0&id=f96b62d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96b62d4"]])

export default __exports__